<ion-menu-toggle id="sentry-user-feedback" class="w-full flex justify-start items-center gap-[10px] py-[10px]">
	<ion-icon color="light" name="bug-outline"></ion-icon>
	<ion-text class="text-lg uppercase text-(--ion-color-light)">
		{{ 'Report Bug' | translate }}
	</ion-text>
</ion-menu-toggle>
